<template>
    <div>
        <canvas id="canvas" ref="canvas"></canvas>
    </div>
</template>

<script>
    import Chart from "chart.js";
    import ChartDataLabels from 'chartjs-plugin-datalabels';
    Chart.plugins.unregister(ChartDataLabels);

    export default {
        name: "ChartHalfDonut",

        props: {
            'data': {},
            'headline': {
                default: 'Headline',
            },
            longtext: {
                default: false,
            },
            colors: {
                default:() => ([
                    '#FF968A',
                    '#CCE2CB',
                ]),
            }
        },


        watch: {
            json() {
                this.chart();
            }
        },


        computed: {
            items() {
                return this.data.map(function (item) {
                    return item.value;
                })
            },
            labels() {
                return this.data.map(function (item) {
                    return item.label;
                })
            },
            json() {
                return {
                    type: 'doughnut',
                    plugins: this.data.length <= 10 ? [ChartDataLabels] : [],
                    data: {
                        labels: this.labels,
                        datasets:
                            [{
                                label: this.headline,
                                data: this.items,
                                backgroundColor: this.colors,
                            }]
                    },
                    options: {
                        rotation: Math.PI,
                        circumference: Math.PI,
                        responsive: true,
                        plugins: {
                            datalabels: {
                                color: 'grey',
                            }
                        },
                        legend: {
                            display: true,
                            position: 'bottom',
                        },
                        title: {
                            display: false,
                            text: 'Chart.js Bar Chart'
                        },
                        scales: {
                            yAxes: [{
                                display: false,
                            }],
                            xAxes: [{
                                display: false,
                            }],
                        }
                    }
                };
            }
        },

        mounted() {
            this.chart()
        },

        methods: {
            chart() {
                new Chart(this.$refs.canvas, this.json);
            }
        }
    }
</script>

<style scoped>

</style>
